module.exports = __webpack_public_path__ + "media/images/pages/mixta-jumper-kidom-10a26063eb8e31199e348c6575908af2.jpg";